export default __webpack_public_path__ + "static/media/th.4a3b8823.svg";